import { Button, Flex } from '@chakra-ui/react';

interface StepNavigationProps {
  onPrevious: () => void;
  onNext: () => void;
  showPrevious?: boolean;
  showNext?: boolean;
  nextLabel?: string;
  currentStep?: number;
  totalSteps?: number;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({
  onPrevious,
  onNext,
  showPrevious = true,
  showNext = true,
  nextLabel = 'NEXT',
  currentStep,
  totalSteps,
}) => {
  return (
    <Flex
      position="fixed"
      bottom={0}
      left={0}
      width="100%"
      justify="center"
      bg="white"
      borderTopWidth="1px"
      borderColor="gray.100"
    >
      <Flex
        w="100%"
        maxW="600px"
        justify="space-between"
        align="center"
        px={6}
        py={4}
      >
        <Button
          variant="outline"
          onClick={onPrevious}
          colorPalette="green"
          fontWeight="semibold"
          fontSize="sm"
          borderRadius="full"
          px={5}
          visibility={showPrevious ? 'visible' : 'hidden'}
          _hover={{ bg: 'green.50', transform: 'translateY(-1px)' }}
          transition="all 0.2s"
        >
          ‹ PREVIOUS
        </Button>

        {/* Progress Indicator */}
        {currentStep !== undefined && totalSteps !== undefined && (
          <Flex align="center" gap={2}>
            {Array.from({ length: totalSteps }, (_, i) => (
              <Flex
                key={i}
                w={i + 1 === currentStep ? '24px' : '8px'}
                h="8px"
                borderRadius="full"
                bg={i + 1 <= currentStep ? 'green.500' : 'gray.200'}
                transition="all 0.3s"
              />
            ))}
          </Flex>
        )}

        <Button
          onClick={onNext}
          colorPalette="green"
          fontWeight="semibold"
          fontSize="sm"
          borderRadius="full"
          px={5}
          visibility={showNext ? 'visible' : 'hidden'}
          _hover={{ transform: 'translateY(-1px)', boxShadow: 'md' }}
          transition="all 0.2s"
        >
          {nextLabel} ›
        </Button>
      </Flex>
    </Flex>
  );
};
